import App from './App.vue'
import { createApp } from 'vue'

import store from '@/frontend/plugins/store'
import useRouter from '@/frontend/plugins/route'
import useRoutes from "@/frontend/plugins/route/routes";
import UserApi from '@/frontend/api/user'
import attachDirectives from '@/frontend/functions/directivesInit'
import VueCookies from 'vue-cookies'
import Vue3MobileDetection from "vue3-mobile-detection";

const app = createApp(App)

UserApi.getAccess()
    .then(response => store.dispatch('initAccess', response))
    .catch(error => console.log(error))
    .finally(() => {
        attachDirectives(app)
        app.use(store)
        app.use(useRouter(useRoutes(store)))
        // default options config: { expires: '1d', path: '/', domain: '', secure: '', sameSite: 'Lax' }
        app.use(VueCookies)
        app.use(Vue3MobileDetection)
        app.mount('#app')
    })